import { useState } from "react";
import { useContext} from "react";
import { ThemeContext } from "../../context/ThemeContext";

function TickButton({on}){
    const theme = useContext(ThemeContext);
    const {dark} = theme;
    const [changed, setChange] = useState(false);
    function clickHandler(){
        setChange(true);
    }
    return (
        <button onClick={clickHandler}>
            <svg width="16" height="16" viewBox="0 0 16 16" className={`${changed || on ? " fill-green-500":(dark? " fill-neutral-300": " fill-neutral-300")}`}>
                <path fillRule="evenodd" clipRule="evenodd" d="M8 16C10.1217 16 12.1566 15.1571 13.6569 13.6569C15.1571 12.1566 16 10.1217 16 8C16 5.87827 15.1571 3.84344 13.6569 2.34315C12.1566 0.842855 10.1217 0 8 0C5.87827 0 3.84344 0.842855 2.34315 2.34315C0.842855 3.84344 0 5.87827 0 8C0 10.1217 0.842855 12.1566 2.34315 13.6569C3.84344 15.1571 5.87827 16 8 16ZM11.707 6.707C11.8892 6.5184 11.99 6.2658 11.9877 6.0036C11.9854 5.7414 11.8802 5.49059 11.6948 5.30518C11.5094 5.11977 11.2586 5.0146 10.9964 5.01233C10.7342 5.01005 10.4816 5.11084 10.293 5.293L7 8.586L5.707 7.293C5.5184 7.11084 5.2658 7.01005 5.0036 7.01233C4.7414 7.0146 4.49059 7.11977 4.30518 7.30518C4.11977 7.49059 4.0146 7.7414 4.01233 8.0036C4.01005 8.2658 4.11084 8.5184 4.293 8.707L6.293 10.707C6.48053 10.8945 6.73484 10.9998 7 10.9998C7.26516 10.9998 7.51947 10.8945 7.707 10.707L11.707 6.707Z"/>
            </svg>
        </button>
    )
}

export default TickButton;